'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import { useStore } from '@base-ui/utils/store';
import { useSchedulerStoreContext } from "../../use-scheduler-store-context/index.mjs";
import { schedulerEventSelectors } from "../../scheduler-selectors/index.mjs";
export function useEventCreation(getCreationPlaceholder) {
  const store = useSchedulerStoreContext();
  const creationConfig = useStore(store, schedulerEventSelectors.creationConfig);
  if (creationConfig === false) {
    return {};
  }
  const handler = event => {
    const target = event.target;
    // Don't create events when clicking on existing events
    if (target !== event.currentTarget && target.closest('button, [role="button"]')) {
      return;
    }
    store.setOccurrencePlaceholder(_extends({
      type: 'creation'
    }, getCreationPlaceholder({
      event,
      creationConfig
    })));
  };
  if (creationConfig.interaction === 'double-click') {
    return {
      onDoubleClick: handler
    };
  }
  return {
    onClick: handler
  };
}